import { PublicClientApplication } from "@azure/msal-browser";
 
const azureB2cConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_B2C_CLIENT_ID,
    authority: process.env.VUE_APP_B2C_AUTHORITY,
    redirectUri: process.env.VUE_APP_REDIRECT_LOGIN_URI,  // points to /login, not /home
    knownAuthorities: ["aucera.b2clogin.com"],
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};
 
const azureAdConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID,
    authority: process.env.VUE_APP_AZURE_AUTHORITY,
    redirectUri: process.env.VUE_APP_REDIRECT_URI || process.env.VUE_LOCAL_HOST_HOME,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};
 
// Singleton MSAL instance — prevents multiple-instance errors across the app
let _msalInstance = null;
async function getMsalInstance() {
  if (!_msalInstance) {
    _msalInstance = new PublicClientApplication(azureB2cConfig);
    await _msalInstance.initialize();
  }
  return _msalInstance;
}
 
function getB2cScopes() {
  return [
    "openid",
    "profile",
    "email",
    `https://${process.env.VUE_APP_B2C_INSTANCE}/${process.env.VUE_APP_BACKEND_CLIENT_ID}/demo.read`,
  ];
}
 
export default {
  getMsalInstance,
  getB2cScopes,
  getAzureAdConfig() {
    if (!azureAdConfig.auth.clientId || !azureAdConfig.auth.authority) {
      console.error("Azure AD configuration is missing required values.");
      return null;
    }
    return azureAdConfig;
  },
  getAzureB2cConfig() {
    if (!azureB2cConfig.auth.clientId || !azureB2cConfig.auth.authority) {
      console.error("Azure B2C configuration is missing required values.");
      return null;
    }
    return azureB2cConfig;
  },
}; 